const DOMAIN_NAME = process.env.REACT_DOMAIN_NAME || '.acuvue.com';

const CookieService = {
  getCookie: property => {
    const name = `${property}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },

  setCookie: (name, value) => {
    const date = new Date();
    date.setTime(date.getTime() + 120 * 24 * 60 * 60 * 1000);
    const expires = date.toUTCString();
    document.cookie = `${name}=${value};expires=${expires}`;
  },

  clearCookie: value => {
    const expires = new Date().toUTCString();
    document.cookie = `${value}=;domain=${DOMAIN_NAME}; expires=${expires}`;
  },

  checkCookieAvailability: value => {
    const data = CookieService.getCookie(value);
    return data !== '';
  },
};

export default CookieService;
